/* eslint import/no-unresolved: 0 */
import PropTypes from 'prop-types';
import { useRef, useEffect } from 'react';
import { createPortal } from 'react-dom';
import { useIntl } from '@edx/frontend-platform/i18n';

import { useContextId } from '@src/data/hooks';
import { useModel } from '@src/generic/model-store';
import PageLoading from '@src/generic/PageLoading';
import genericMessages from '@src/tab-page/messages';
import SectionItem from './SectionItem';
import UpgradeBanner from './UpgradeBanner';
import useSequenceContext from './hooks';

const SectionList = ({ expandAll, sections, sectionIds }) => {
  const intl = useIntl();
  const portalRef = useRef(null);
  const courseId = useContextId();

  const {
    verifiedMode,
  } = useModel('courseHomeMeta', courseId);
  const {
    datesBannerInfo,
  } = useModel('outline', courseId);

  const isFBE = !!datesBannerInfo?.contentTypeGatingEnabled;
  const upgradeUrl = isFBE && verifiedMode?.upgradeUrl;

  const {
    courseHasLockedContent,
    fetchSectionHasLockedContent,
    isLoading,
    sequenceData,
  } = useSequenceContext({ sections, isFBE });

  const hasLockedContent = upgradeUrl && courseHasLockedContent;

  useEffect(() => {
    const referenceNode = document.getElementById('expand-button-row');
    const portalNode = document.createElement('div');
    referenceNode.parentNode.insertBefore(portalNode, referenceNode);
    portalRef.current = portalNode;
  }, []);

  if (isLoading) {
    return (
      <PageLoading srMessage={intl.formatMessage(genericMessages.loading)} />
    );
  }

  return (
    <>
      {hasLockedContent && portalRef.current && createPortal(
        <UpgradeBanner {...{ upgradeUrl }} />,
        portalRef.current,
      )}
      <ol id="courseHome-outline" className="list-unstyled">
        {sectionIds.map((sectionId) => (
          <SectionItem
            key={sectionId}
            sectionId={sectionId}
            defaultOpen={sections[sectionId].resumeBlock}
            expand={expandAll}
            section={sections[sectionId]}
            upgradeUrl={upgradeUrl}
            courseId={courseId}
            sequenceData={sequenceData}
            fetchSectionHasLockedContent={fetchSectionHasLockedContent}
          />
        ))}
      </ol>
    </>
  );
};

SectionList.propTypes = {
  expandAll: PropTypes.bool.isRequired,
  sections: PropTypes.shape().isRequired,
  sectionIds: PropTypes.arrayOf(PropTypes.string).isRequired,
};

export default SectionList;
